import { useQuery } from '@tanstack/react-query';
import { fetchSystemEnvironment } from '../lib/system.api';

const SYSTEM_ENVIRONMENT_KEY = ['system', 'environment'];

/**
 * Whether this deploy is production. Backed by the real NODE_ENV on the
 * server, not a Vite build-time flag — staging and production run the same
 * production-mode Vite build, so import.meta.env.PROD/DEV can't tell them
 * apart. Never changes for the lifetime of a deploy, so it's cached forever.
 */
export function useIsProductionEnvironment(): boolean {
  const { data } = useQuery({
    queryKey: SYSTEM_ENVIRONMENT_KEY,
    queryFn: fetchSystemEnvironment,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  // Fail closed: until we know, or if the check fails, hide production-hidden items.
  return data?.isProduction ?? true;
}
